module.exports = __webpack_public_path__ + "fonts/fa-regular-400.fb332093a8495d617b00df27293c0be6.woff";